"use client";

import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { filtersAtomObject } from "../../state";

export const RemoteWorkingFilter = ({ onChange, initialState = false }) => {

  const [filters] = useAtom(
   filtersAtomObject
  );

  const handleOnChange = () => {
   onChange(!filters.remoteWorking);
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="filter-single">
        <div className="filter">
          <div className="element switch form-group">
            <div className="field">
              <div className="icheck-primary">
                <label className="" htmlFor="remoteWorkingCheckbox">
                  <input
                    type="checkbox"
                    id="remoteWorkingCheckbox"
                    checked={filters.remoteWorking === true}
                    onChange={handleOnChange}
                  />
                  <span className="slider"></span>
                  <span className="faux-label">
                    {t("remote_working")}
                    {initialState.count > 0 && (
                      <span className="count">{initialState?.count}</span>
                    )}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RemoteWorkingFilter;
